module.exports = __webpack_public_path__ + "img/symbol_6.51bcdce5.png";